<app-nav-bar></app-nav-bar>
<div fxLayout="column" fxLayoutAlign="center none" class="mat-app-background basic-container">
  <router-outlet></router-outlet>
</div>
